export default {
	referenceGrid: {
		bindsInfo: "Інформація про прив'язки",
		appsToWhichBaseLinked: "Програми, до яких прив'язана база",
		toUnlinkAppsGoToDeleteMenu: "Для відв'язки програм від бази перейдіть в меню видалення",
		currentBaseNotLinkedToApp: "База не прив'язана до програм",
		basesLinkedToApp: "Бази, що прив'язані до програми",
		packetsWithSection: "Пакети, де приймає участь програма",
		noPacketsWithSection: "жодний пакет не містить цієї програми",
		toDeletePackets: "Для видалення пакетів перейдіть до Крону відповідного сервера",
		toUnlinkBasesGoToDeleteMenu: "Для відв'язки баз від програми перейдіть в меню видалення",
		noLinkedBasesToCurrentApp: "до даної програми не прив'язана жодна база",
		enterDataForNewApp: "Введіть дані нової програми",
		copied: "Копіюється",
		copyAttention: "Увага: копіювання програми відбувається в межах одного серверу",
		name: "Назва",
		alias: "Аліас",
		path: "Шлях",
		cancel: "Відмінити",
		insert: "Додати",
		copy: "Копіювати",
		info: "Інформація",
		edit: "Редагувати",
		delete: "Видалити",
		view: "Вигляд",
		compact: "Оптимальний",
		full: "Повний",
		enterNameForNewApp: "Введіть назву нової програми",
		enterPathForNewApp: "Введіть шлях нової програми",
		desirableEnterAliasField: "Бажано заповнювати поле 'Аліас'",
		continueWithoutAlias: "Продовжити без заповнювання",
		attention: "Увага",
		continue: "Далі",
		return: "Назад"
	}
}